module.exports = __webpack_public_path__ + "static/media/test-desktop-1920.61ae3f5f.jpg";